module.exports = __webpack_public_path__ + "static/media/tracebot_confused.c99a5fc2.svg";